// extracted by mini-css-extract-plugin
export default {"rootWrapper":"App_rootWrapper__prqkg","header":"App_header__IDb1j","page":"App_page__ap+QU"};